import { Box } from '@mui/material';
import ReactJson from 'react-json-view';
import GeneralButton from '../../../Components/GeneralButton';
import { useContext } from 'react';
import { FvpConfigContext } from '../../../Contexts/FvpConfigContext';
import { UserContext } from '../../../Contexts/UserContext';
// Styles
import { toast } from 'react-toastify';
////////
import checkFvpConfig from '../../../utilities/fvpConfigCheck';
import { ACCESS_CONTROL_CONSTANTS, FVP_CONFIG_EDIT_MODES } from '../../../core/constants';
import { createFvpConfigForSite, syncFvpSite, updateFvpConfigInDb } from '../../../api/fvpDoc';
import { generateConfig } from '../../../utilities/helpers';
import useStyles from '../styles';

const FinalOverview = () => {
	const classes = useStyles();
	const { fvpConfig, fvpConfigEditMode, updateFvpConfigMode, previousFvpCouchBaseConfig } =
		useContext(FvpConfigContext);
	const { user } = useContext(UserContext);

	const getFinalOverviewObj = () => {
		const clonedFvpConfig = structuredClone(fvpConfig);
		clonedFvpConfig.ads = {};

		for (const videoSectionId in fvpConfig.ads) {
			clonedFvpConfig.ads[videoSectionId] = generateConfig(fvpConfig.ads[videoSectionId]);
		}
		return clonedFvpConfig;
	};

	const overviewObject = getFinalOverviewObj();
	const shouldDisableUpdateAndSync = !overviewObject?.fallbackXmlConfig?.enabled || overviewObject?.fallbackXmlConfig?.vastTagUrls?.length === 0;

	const handleSubmit = async () => {
		if (!user) {
			toast.error('No user found!', { position: toast.POSITION.BOTTOM_RIGHT });
			return;
		}

		if (!user.isAdmin) {
			toast.error('User not allowed to create or update!!', {
				position: toast.POSITION.BOTTOM_RIGHT
			});
			return;
		}

		try {
			const overviewObject = getFinalOverviewObj();
			checkFvpConfig(overviewObject);

			const payload = {
				data: overviewObject
			};

			if (fvpConfigEditMode === FVP_CONFIG_EDIT_MODES.CREATE) {
				await createFvpConfigForSite(payload);
				updateFvpConfigMode(FVP_CONFIG_EDIT_MODES.UPDATE);
			} else {
				await updateFvpConfigInDb(payload);
			}

			previousFvpCouchBaseConfig.current = overviewObject;
			toast.success('Successfully Done!', { position: toast.POSITION.BOTTOM_RIGHT });
		} catch (err) {
			console.log(err);
			const requestError = err?.response?.data?.data?.message || err.message;
			toast.error(requestError, { position: toast.POSITION.BOTTOM_RIGHT });
		}
	};

	const handleSyncSite = async () => {
		try {
			const overviewObject = getFinalOverviewObj();
			checkFvpConfig(overviewObject);

			await syncFvpSite(overviewObject.siteId);
			toast.success('Site Sync Initiated!', { position: toast.POSITION.BOTTOM_RIGHT });
		} catch (err) {
			console.log(err);
			const requestError = err?.response?.data?.data?.message || err.message;
			toast.error(requestError, { position: toast.POSITION.BOTTOM_RIGHT });
		}
	};

	return (
		<>
			<Box
				style={{
					position: 'absolute',
					bottom: '6rem',
					right: '50%',
					transform: 'translate(50%,50%)',
					width: '25rem',
					display: 'flex',
					justifyContent: 'space-between'
				}}
			>
				<GeneralButton
					system={ACCESS_CONTROL_CONSTANTS.SYSTEMS.FVP_PLAYER}
					name={'FVP_CONFIG_CREATE_DOC_BUTTON'}
					variant="contained"
					onClick={handleSubmit}
					disable={shouldDisableUpdateAndSync}

				>
					{fvpConfigEditMode === FVP_CONFIG_EDIT_MODES.CREATE ? 'Create' : 'Update'} Doc
				</GeneralButton>
				<GeneralButton variant="contained" onClick={handleSyncSite} disable={shouldDisableUpdateAndSync}>
					Sync Site
				</GeneralButton>
			</Box>
			<Box className={classes.finalOverview}>
				<ReactJson
					name={false}
					enableClipboard={true}
					displayDataTypes={false}
					src={getFinalOverviewObj()}
				/>
			</Box>
		</>
	);
};

export default FinalOverview;
